import { ICON_SVG } from './iconMarker';

/** In px: 12 to 24 for icons next to text, 32 to 64 for large illustrative ones, such as an empty state's. */
export const ICON_SIZES = [12, 14, 16, 18, 20, 24, 32, 48, 64] as const;

export type IconSize = (typeof ICON_SIZES)[number];

/** For an icon inside a line of text, so it follows the font size; a slot doesn't take it, since it sizes in px. */
export type TextIconSize = '1em';

/** How deep below the slot element the icon sits. */
export type IconSlotReach = 'child' | 'wrapped' | 'grandchild';

const SELECTORS: Record<IconSlotReach, string> = {
    child: `& > ${ICON_SVG}`,
    wrapped: `& > ${ICON_SVG}, & > * > ${ICON_SVG}`,
    grandchild: `& * > ${ICON_SVG}`,
};

/** Sizes the icon in a slot, beating an `sx` or `size` on the icon; only an inline `style` overrides it. */
export function iconSlot(
    size: IconSize,
    { reach = 'child' }: { reach?: IconSlotReach } = {},
): Record<string, { width: string; height: string }> {
    return { [SELECTORS[reach]]: { width: `${size}px`, height: `${size}px` } };
}
